import type { CreateApiKeyPayload, CreateApiKeyResponse } from '#layers/access/utils/api/api-keys';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { createApiKey } from '#layers/access/utils/api/api-keys';
import { useToastResultHandling } from '#layers/ui/public';

export function useApiKeyGeneration() {
	const { t } = useI18n();
	const { onError: generateError } = useToastResultHandling({
		error: {
			title: t('api_keys.create_error'),
		},
	});
	const isGenerating = ref(false);
	const generatedToken = ref<string | null>(null);

	/** Creates an API key, returning the response, or `null` when a request is already in flight or failed. */
	async function generate(payload: CreateApiKeyPayload): Promise<CreateApiKeyResponse | null> {
		if (isGenerating.value) return null;

		isGenerating.value = true;

		try {
			const result = await createApiKey(payload);
			generatedToken.value = result.key;
			return result;
		}
		catch (error) {
			generateError(error);
			return null;
		}
		finally {
			isGenerating.value = false;
		}
	}

	return { isGenerating, generatedToken, generate };
}
